"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _ApiClient = _interopRequireDefault(require("../ApiClient"));

/**
 * The ApiEventRequest model module.
 * @module ChiRhos/models/ApiEventRequest
 * @version v1
 */
var ApiEventRequest =
/*#__PURE__*/
function () {
  /**
   * Constructs a new <code>ApiEventRequest</code>.
   * @alias module:ChiRhos/models/ApiEventRequest
   * @class
   * @param from {Date}
   * @param to {Date}
   * @param includeDeleted {Boolean}
   * @param entityId {String}
   */
  function ApiEventRequest(from, to, includeDeleted, entityId) {
    (0, _classCallCheck2["default"])(this, ApiEventRequest);
    (0, _defineProperty2["default"])(this, "from", undefined);
    (0, _defineProperty2["default"])(this, "to", undefined);
    (0, _defineProperty2["default"])(this, "includeDeleted", undefined);
    (0, _defineProperty2["default"])(this, "entityId", undefined);
    (0, _defineProperty2["default"])(this, "pointInTime", undefined);
    this['from'] = from;
    this['to'] = to;
    this['includeDeleted'] = includeDeleted;
    this['entityId'] = entityId;
  }
  /**
   * Constructs a <code>ApiEventRequest</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:ChiRhos/models/ApiEventRequest} obj Optional instance to populate.
   * @return {module:ChiRhos/models/ApiEventRequest} The populated <code>ApiEventRequest</code> instance.
   */


  (0, _createClass2["default"])(ApiEventRequest, null, [{
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new ApiEventRequest();

        if (data.hasOwnProperty('from')) {
          obj['from'] = _ApiClient["default"].convertToType(data['from'], 'Date');
        }

        if (data.hasOwnProperty('to')) {
          obj['to'] = _ApiClient["default"].convertToType(data['to'], 'Date');
        }

        if (data.hasOwnProperty('includeDeleted')) {
          obj['includeDeleted'] = _ApiClient["default"].convertToType(data['includeDeleted'], 'Boolean');
        }

        if (data.hasOwnProperty('entityId')) {
          obj['entityId'] = _ApiClient["default"].convertToType(data['entityId'], 'String');
        }

        if (data.hasOwnProperty('pointInTime')) {
          obj['pointInTime'] = _ApiClient["default"].convertToType(data['pointInTime'], 'Date');
        }
      }

      return obj;
    }
    /**
     * @member {Date} from
     */

  }]);
  return ApiEventRequest;
}();

exports["default"] = ApiEventRequest;
module.exports = exports.default;